import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '../withNavLayout';

// utils
import { breadcrumbsTranslations } from './utils/breadcrumbsTranslations';

const Breadcrumbs = () => {
  const themes = useSelector((state) => state.themes);
  const { darkCompactTheme, darkTheme, lightCompactTheme, lightTheme } = themes;

  const { navItems } = useNavigation();

  const { pathname } = useLocation();

  const translations = useMemo(
    () => breadcrumbsTranslations(pathname, navItems),
    [pathname]
  );

  return (
    <div
      className={
        darkCompactTheme
          ? 'breadcrumbs breadcrumbs--compact'
          : darkTheme
          ? 'breadcrumbs'
          : lightCompactTheme
          ? 'breadcrumbs breadcrumbs--compact breadcrumbs--light'
          : lightTheme
          ? 'breadcrumbs breadcrumbs--light'
          : ''
      }
    >
      <ul className="breadcrumbs__list">
        {translations.map((el, index) => (
          <React.Fragment key={el + index}>
            <li className="breadcrumbs__list__item">{el}</li>
            {translations.length !== index + 1 && (
              <span className="breadcrumbs__list__direction">&gt;</span>
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
